import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=023130da&"
import script from "./Dialog.vue?vue&type=script&lang=js&"
export * from "./Dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('023130da')) {
      api.createRecord('023130da', component.options)
    } else {
      api.reload('023130da', component.options)
    }
    module.hot.accept("./Dialog.vue?vue&type=template&id=023130da&", function () {
      api.rerender('023130da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/Dialog.vue"
export default component.exports